const stateMap = {
  N: 'DEVELOPER_TITLES.SLUG.NEW',
  R: 'DEVELOPER_TITLES.SLUG.REJECTED',
  A: 'DEVELOPER_TITLES.SLUG.ACCEPTED',
};

export default function getStateTranslation(state) {
  return stateMap[state];
}
